import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            hasNewVersion: false,
            intervalId: 0,
        }
    },
    computed: {
        isDev() {
            return process.env.NODE_ENV === 'development'
        },
    },
    methods: {
        check() {
            if (this.isDev) {
                return
            }

            fetch(process.env.VUE_APP_BASE_URL)
                .then((res) => res.text())
                .then((documentText) => {
                    const group = /data-app-version="'(.*)'"/g.exec(documentText)

                    if (!group) {
                        return
                    }

                    const [, newVersion] = group
                    // @ts-ignore -- versionText is defined in src/_mixins/app.ts
                    const currentVersion = this.versionText
                    if (currentVersion && newVersion) {
                        this.hasNewVersion = newVersion != currentVersion
                    }
                })
        },
        reset() {
            if (this.intervalId) {
                clearInterval(this.intervalId)
                this.intervalId = 0
            }
        },
        onVisibilityChange() {
            if (document.visibilityState === 'visible') {
                this.check()
                this.resume()
            } else {
                this.reset()
            }
        },
        resume() {
            this.reset()

            this.intervalId = setInterval(() => {
                this.check()
            }, 60 * 1000)
        },
    },
    mounted() {
        if (this.isDev) {
            return
        }

        this.resume()
        window.addEventListener('visibilitychange', this.onVisibilityChange)
    },
    beforeDestroy() {
        if (this.isDev) {
            return
        }

        window.removeEventListener('visibilitychange', this.onVisibilityChange)
    },
})
